document.addEventListener("DOMContentLoaded", function () {
  const stickyBars = document.querySelectorAll(".section-header");

  function toggleSticky() {
    stickyBars.forEach(function (bar) {
      if (window.scrollY > 600) {
        bar.classList.add("sticky-header");
      } else {
        bar.classList.remove("sticky-header");
      }
    });
  }

  // Initial check in case page is loaded already scrolled
  toggleSticky();

  // Show sticky bar on scroll
  window.addEventListener("scroll", toggleSticky);
});
